<div class="col px-lg-5 px-2">
	<div class="my-3">
		<div class="row" *ngIf="isSESSAD">
			<!-- REPARTITION DES PLANNINGS -->
			<div class="col">
				<app-planning-repartition
					[lpcStats]="lpcStats"
					[lsfStats]="lsfStats"
					[pdnStats]="pdnStats"
					[oralStats]="oralStats"
				>
				</app-planning-repartition>
			</div>
		</div>
		<div class="row border rounded mt-4">
			<!-- TAUX DE SATISFACTION -->
			<div class="col-md-6">
				<app-satisfaction
					[lpcStats]="lpcStats"
					[lsfStats]="lsfStats"
					[pdnStats]="pdnStats"
					[oralStats]="oralStats"
					[globalStats]="globalStats"
				></app-satisfaction>
			</div>
			<div class="col-md-6">
				<app-satisfaction-unassigned
					[unassignedStats]="unassignedStats"
					[lpcStats]="lpcStats"
					[lsfStats]="lsfStats"
					[pdnStats]="pdnStats"
					[oralStats]="oralStats"
					[globalStats]="globalStats"
				></app-satisfaction-unassigned>
			</div>
		</div>
		<!-- TEMPS DE TRAVAIL PAR EMPLOYE -->
		<div class="row p-4">
			<div class="col">
				<app-working-time-by-user
					[statsEmployee]="statsEmployee"
				></app-working-time-by-user>
			</div>
		</div>
		<!-- TEMPS DE TRAVAIL (TOTALE ET PAR SPÉCIALITÉ) -->
		<div class="row p-4">
			<div class="col">
				<app-working-time
					[globalStats]="globalStats"
					[lpcStats]="lpcStats"
					[lsfStats]="lsfStats"
					[pdnStats]="pdnStats"
					[oralStats]="oralStats"
					[stats]="stats"
				></app-working-time>
			</div>
		</div>
		<!-- DISTANCE PARCOURUE PAR EMPLOYÉ PERIODIQUEMENT (TOTALE ET PAR SPÉCIALITÉ) -->
		<div class="row p-4">
			<div class="col">
				<!-- <app-travel-distance-periodicity></app-travel-distance-periodicity> -->
			</div>
		</div>
		<!-- DISTANCE PARCOURUE PAR EMPLOYÉ  -->
		<div class="row p-4">
			<div class="col">
				<app-travel-distance-by-user
					[statsEmployee]="statsEmployee"
				></app-travel-distance-by-user>
			</div>
		</div>

		<!-- DISTANCE PARCOURUE (TOTALE ET PAR SPÉCIALITÉ) -->
		<div class="row p-4">
			<div class="col">
				<app-travel-distance
					[lpcStats]="lpcStats"
					[lsfStats]="lsfStats"
					[pdnStats]="pdnStats"
					[oralStats]="oralStats"
					[globalStats]="globalStats"
					[stats]="stats"
				>
				</app-travel-distance>
			</div>
		</div>
	</div>
</div>
